import React from 'react';
import {
  ShipmentQuotesList,
  ShipmentQuotesTable
} from 'src/components/ShipmentQuotes';
import {
  Card,
  Col,
  Icon,
  Link,
  ListGroup,
  ListGroupItem,
  Row,
  ScreenSize,
  Table,
  TableBody,
  TableData,
  TableHead,
  TableHeader,
  TableRow,
  useApp
} from 'straightline-ui';

export default function ShipmentQuotesCard() {
  const app = useApp();
  const {
    result: shipmentQuotes,
    isLoading,
    isError
  } = app.service('api/shipment-quotes').useFind(
    {
      query: {
        $limit: 5,
        $sort: { expired_at: -1 },
        $select: [
          'id',
          'pickup_address',
          'delivery_address',
          'pickup_date',
          'due_date',
          'truck_type',
          'expired_at',
          'accepted_at',
          'mode',
          'line_items',
          'travel',
          'shipper_id',
          'rates',
          'load_weight',
          'rate_id'
        ]
      }
    },
    { keepPreviousData: true, refetchInterval: 60000 }
  );

  if (isLoading || isError) {
    return <Loader />;
  }

  if (shipmentQuotes.total === 0) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      <ScreenSize xs sm md>
        {() => (
          <Card>
            <div className="card-header">
              <div className="d-flex justify-content-between">
                <h3 className="card-header-title">Quotes</h3>
                <Link to="/quotes">View All</Link>
              </div>
            </div>
            <ShipmentQuotesList data={shipmentQuotes.data} />
          </Card>
        )}
      </ScreenSize>
      <ScreenSize lg xl>
        {() => (
          <Card>
            <div className="card-header">
              <div className="d-flex justify-content-between">
                <h3 className="card-header-title">Quotes</h3>
                <Link to="/quotes">View All</Link>
              </div>
            </div>
            <ShipmentQuotesTable data={shipmentQuotes.data} />
          </Card>
        )}
      </ScreenSize>
    </React.Fragment>
  );
}

const Loader = ({ error }) => {
  const loaderLength = [1, 2, 3, 4, 5];
  return (
    <React.Fragment>
      <ScreenSize xs sm md>
        {() => (
          <Card>
            {error && (
              <div className="d-flex align-items-center justify-content-center rounded p-3">
                <div className="lead text-danger">{error.message}</div>
              </div>
            )}
            <div className="card-header">
              <div className="d-flex justify-content-between align-items-center">
                <h3 className="card-header-title">Shipments</h3>
                <Link to="/shipments">View All</Link>
              </div>
            </div>
            <ListGroup className="list-group-flush mb-0">
              {!error &&
                loaderLength.map((item, index) => {
                  return (
                    <ListGroupItem key={index} className="px-4">
                      <div
                      // className="animated flash infinite slower"
                      >
                        <Row className="justify-content-between mb-3">
                          <Col xs="auto">
                            <div
                              className="bg-light rounded"
                              style={{ height: 33, width: 100 }}
                            />
                          </Col>
                          <Col xs="auto">
                            <div className="text-secondary d-flex align-items-center">
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 40 }}
                              />
                              <Icon type="dot" className="text-muted mx-1" />
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 60 }}
                              />
                            </div>
                            <div className="text-secondary d-flex align-items-center">
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 60 }}
                              />
                              <Icon type="dot" className="text-muted mx-1" />
                              <div
                                className="bg-light rounded"
                                style={{ height: 14, width: 40 }}
                              />
                            </div>
                          </Col>
                        </Row>
                        <ListGroup className="list-group list-group-flush list-group-activity">
                          <ListGroupItem className="py-3">
                            <Row>
                              <Col xs="auto">
                                <div className="avatar avatar-sm">
                                  <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                                    <Icon type="clipboard" />
                                  </div>
                                </div>
                              </Col>
                              <Col className="ml-n2">
                                <div
                                  className="bg-light rounded mb-1"
                                  style={{ height: 14, width: 120 }}
                                />
                                <div
                                  className="bg-light rounded mb-1"
                                  style={{ height: 14, width: 100 }}
                                />
                                <div
                                  className="bg-light rounded mb-1"
                                  style={{ height: 14, width: 190 }}
                                />
                                <div
                                  className="bg-light rounded mb-1"
                                  style={{ height: 14, width: 75 }}
                                />
                              </Col>
                            </Row>
                          </ListGroupItem>

                          <ListGroupItem className="py-3">
                            <Row>
                              <Col xs="auto">
                                <div className="avatar avatar-sm">
                                  <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                                    <Icon type="truck" />
                                  </div>
                                </div>
                              </Col>
                              <Col className="ml-n2">
                                <div>
                                  <div
                                    className="bg-light rounded mb-2"
                                    style={{ height: 18, width: 160 }}
                                  />
                                  <div>
                                    <div
                                      className="bg-light rounded"
                                      style={{ height: 16, width: 140 }}
                                    />
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </ListGroupItem>
                          <ListGroupItem className="pt-3 pb-0">
                            <Row>
                              <Col xs="auto">
                                <div className="avatar avatar-sm">
                                  <div className="avatar-title font-size-lg rounded-circle bg-light text-dark">
                                    <Icon type="map-pin" />
                                  </div>
                                </div>
                              </Col>
                              <Col className="ml-n2">
                                <div>
                                  <div
                                    className="bg-light rounded mb-2"
                                    style={{ height: 18, width: 170 }}
                                  />
                                  <div
                                    className="bg-light rounded"
                                    style={{ height: 18, width: 170 }}
                                  />
                                </div>
                              </Col>
                            </Row>
                          </ListGroupItem>
                        </ListGroup>
                      </div>
                    </ListGroupItem>
                  );
                })}
            </ListGroup>
          </Card>
        )}
      </ScreenSize>
      <ScreenSize lg xl>
        {() => (
          <Card>
            <div className="card-header">
              <div className="d-flex justify-content-between">
                <h3 className="card-header-title">Quotes</h3>
                <Link to="/quotes">View All</Link>
              </div>
            </div>
            {error && (
              <div className="d-flex align-items-center justify-content-center rounded p-3">
                <div className="font-weight-bold text-danger">
                  {error.message}
                </div>
              </div>
            )}
            {!error && (
              <div className="table-responsive">
                <Table className="table table-nowrap card-table table-hover">
                  <TableHead>
                    <TableRow>
                      <TableHeader className="py-3">Price</TableHeader>
                      <TableHeader className="py-3">Pickup</TableHeader>
                      <TableHeader className="py-3" style={{ paddingLeft: 38 }}>
                        Delivery
                      </TableHeader>
                      <TableHeader className="py-3" colSpan="2">
                        Status
                      </TableHeader>
                    </TableRow>
                  </TableHead>
                  <TableBody className="list">
                    {loaderLength.map((item) => {
                      return (
                        <TableRow key={item}>
                          <TableData>
                            <div
                              className="bg-light rounded mb-2"
                              style={{ height: 18, width: 85 }}
                            />
                            <div
                              className="bg-light rounded"
                              style={{ height: 18, width: 40 }}
                            />
                          </TableData>
                          <TableData className="pr-0">
                            <div
                              className="bg-light rounded mb-2"
                              style={{ height: 18, width: 78 }}
                            />
                            <div
                              className="bg-light rounded"
                              style={{ height: 18, width: 65 }}
                            />
                          </TableData>
                          <TableData className="pl-0">
                            <div className="d-inline-block mx-2">
                              <Icon
                                type="arrow-right"
                                className="text-light"
                                style={{ fontSize: 25 }}
                              />
                            </div>
                            <div className="d-inline-block">
                              <div
                                className="bg-light rounded mb-2"
                                style={{ height: 18, width: 78 }}
                              />
                              <div
                                className="bg-light rounded"
                                style={{ height: 18, width: 65 }}
                              />
                            </div>
                          </TableData>
                          <TableData>
                            <div
                              className="bg-light rounded mb-2"
                              style={{ height: 18, width: 100 }}
                            />
                            <div
                              className="bg-light rounded"
                              style={{ height: 18, width: 65 }}
                            />
                          </TableData>
                          <TableData>
                            <div
                              className="bg-light rounded d-inline-block mr-2"
                              style={{ height: 41, width: 142 }}
                            />
                            <div
                              className="bg-light rounded d-inline-block mr-2"
                              style={{ height: 41, width: 142 }}
                            />
                          </TableData>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </div>
            )}
          </Card>
        )}
      </ScreenSize>
    </React.Fragment>
  );
};
